import React, { useState } from "react";
import MainCard from "../../components/cards/MainCard";
import { IconButton, Tooltip, Typography } from "@mui/material";
import Content from "./Content";
import SyncIcon from "@mui/icons-material/Sync";
import useCases from "../../../hooks/useCases";

const DocExplorer = () => {
  const [rotated, setRotated] = useState(false);
  const [search, setSearch] = useState<string>("");
  const { cases, isLoading, handleRefetchUsers } = useCases(
    undefined,
    search,
    { page: 0, pageSize: 1000 },
    [{ field: "createdAt", sort: "desc" }],
    false,
    [
      // [
      //   { title: "Active" },
      //   { title: "Prospect" },
      //   { title: "InReview" },
      //   { title: "Retained" },
      //   { title: "UnRetained" },
      // ],
    ]
  );

  const handleRefetch = () => {
    setRotated((prev) => !prev);
    handleRefetchUsers();
  };

  return (
    <MainCard
      title={
        <Typography
          variant={window?.innerWidth < 1420 ? "h2" : "h1"}
          sx={{ mx: 2 }}
        >
          Doc Explorer
        </Typography>
      }
      actions={
        <Tooltip title={"Refetch Documents"}>
          <IconButton disableRipple onClick={() => handleRefetch()}>
            <SyncIcon
              style={{
                transform: rotated ? "rotate(360deg)" : "rotate(0deg)",
                transition: "transform 1s ease",
              }}
            />
          </IconButton>
        </Tooltip>
      }
      content={
        <Content
          search={search}
          setSearch={setSearch}
          cases={cases}
          isLoading={isLoading}
        />
      }
    />
  );
};

export default DocExplorer;
